import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

import { Lightbox } from 'ngx-lightbox';

import { IAlbum } from '../../../../core/models/patient/patient';
import {
  PatientChildren,
} from '../../../../core/models/patient/patientChildren';
import { PatientService } from '../../../../core/services/v2/patient.service';
import {
  WindowLoaderService,
} from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-children-or-guardian',
  templateUrl: './children-or-guardian.component.html',
  styleUrls: ['./children-or-guardian.component.scss']
})
export class ChildrenOrGuardianComponent implements OnInit {
  @Input() isParams = false;
  @Input() editEnable:boolean = true;
  @Input() childrenGuardians: PatientChildren[];
  @Output() toggleEditEvent = new EventEmitter();
  private previewBoxDialogBox: MatDialogRef<TemplateRef<any>>;
  @ViewChild('previewBox', { static: false }) previewBox: TemplateRef<any>;
  selectedFile = null;
  childrenGuardiansDataSource;
  guardianshipLatter;
  poaLetter;
  patientChildren: PatientChildren;
  previewBoxDataTypeGaurdian:string;
  previewBoxDataTypepoa:string;

  childrelationForm = this.formBuilder.group({
    name: [''],
    birthDate: [''],
    relationship: ['']
  });

  //dataList: PatientChildren[];

  displayedColumnsTrial: string[] = [
    "no","name","Relationship","DOB","Age","PowerofAttorney","GuardianshipLetter", "GuardianshipActionButton",
  ];

  constructor(
    private lightbox: Lightbox,
    private formBuilder: FormBuilder,
    private patientService: PatientService,
    private loaderService: WindowLoaderService,
    private changeDetectorRefs: ChangeDetectorRef,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    //this.dataList = this.childrenGuardians;
    console.log(this.childrenGuardians);
    
    this.childrenGuardiansDataSource = this.childrenGuardians;
  }

  toggleEdit(childreGuardian: PatientChildren) {
    if (childreGuardian) {
      this.toggleEditEvent.emit(childreGuardian);

    } else {
      this.toggleEditEvent.emit(new PatientChildren());
    }
  }

  getAge(dob) {
    let age;
    const convertAge = new Date(dob);
    const timeDiff = Math.abs(Date.now() - convertAge.getTime());
    age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    return age;
  }

  onFileSelectedG(event, child: PatientChildren) {
    this.guardianshipLatter = event.target.files[0];
  }
  onFileSelectedP(event, child: PatientChildren) {
    this.poaLetter = event.target.files[0];
  }

  checkExt(filename) {
    if ((typeof filename) == 'string')
      return filename.split('.').pop();

    return 'blob';
  }

  openLightbox(child: PatientChildren): void {
    this.patientChildren = child;
    this.previewBoxDataTypeGaurdian = this.patientChildren.guardianshipLetter ? this.patientChildren.guardianshipLetter.split(".").pop() : '';
    this.previewBoxDataTypepoa = this.patientChildren.poaLetter ? this.patientChildren.poaLetter.split(".").pop() : '';
    this.previewBoxDialogBox = this.dialog.open(this.previewBox, {
      panelClass: `dialog--popup`,
      width: '800px',
      disableClose: false,
    });

    //this.patientChildren = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    //this.previewBoxDataType =  url.split(".").slice(-1)[0];
    // const album: IAlbum[] = [{ src: url, thumb: url }]
    // this.lightbox.open(album, 0);
  }

  deleteChildrenGuardian(patientId: number, id: number, ind: number) {
    this.loaderService.show();

    this.patientService.deletePatientChild(patientId, id).subscribe(
      (res) => {
        if (res.isSuccess) {
          this.childrenGuardians.splice(ind, 1)
          this.childrenGuardiansDataSource = this.childrenGuardians;
          // const updatedChildrenGuardiansData =
          this.loaderService.hide();
          this.changeDetectorRefs.detectChanges();
        } else
          console.error(res);
      },
      (error) => { console.error(error); },
      () => {
        this.loaderService.hide();
      }
    );

  }
  closeDialogBox() {
    this.previewBoxDialogBox.close();
  }
}

